import { render, staticRenderFns } from "./MemberDetailModal.vue?vue&type=template&id=68837246&scoped=true&"
import script from "./MemberDetailModal.vue?vue&type=script&lang=js&"
export * from "./MemberDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetailModal.vue?vue&type=style&index=0&id=68837246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68837246",
  null
  
)

export default component.exports